export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-07-01 at 10.01.14 PM.aa6004c7.jpeg";